const prox = '_survey_'

export function setLocal(key, value) {
  const val = getLocal(key)
  if (!val.includes(value)) {
    val.push(value)
    localStorage.setItem(prox + key, JSON.stringify(val))
  }
}

export function getLocal(key) {
  let value = localStorage.getItem(prox + key)
  if (value) {
    if (!value.includes('[')) {
      value = [value]
    } else {
      value = JSON.parse(value)
    }
  }
  return value || []
}

export function remove(key) {
  localStorage.removeItem(prox + key)
}
